// The "first label + step" helper for printed page labels. Only its per-page result is stored.

import type { Page } from "./types.ts";

export interface LabelRule {
  /** The first physical page that shows a printed number; earlier pages get "". */
  fromPage: number;
  /** The printed number on `fromPage`. */
  first: number;
  /** How much the printed number goes up per physical page (2 when only odd pages were scanned). */
  step: number;
}

/** Pages with labels from the rule, e.g. {fromPage: 1, first: 5, step: 2} gives 5, 7, 9… */
export function labelPages(pages: readonly Page[], rule: LabelRule): Page[] {
  return pages.map((p) => ({ ...p, label: p.page < rule.fromPage ? "" : String(rule.first + (p.page - rule.fromPage) * rule.step) }));
}
